import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { makeImageSrc } from "theme/components/atoms/Image";
import BackgroundImageViaCss from "theme/components/atoms/Image/BackgroundImageViaCss";

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} RowProps
 *
 * @type {import("react").FC<RowProps>}
 * @todo video components
 */
const Row = ({ children, data }) => {
  const { appearance, backgroundImage, className, styleId } = data;

  const imgUrl = backgroundImage
    ? makeImageSrc(
        backgroundImage, //src
        "large", // format
        undefined, //size
        undefined, // bg
        undefined, //extension
        true // cover
      )
    : "";

  const classes = classnames(className, "pb-row", {
    "pb-row--full-bleed": appearance === "full-bleed",
    "pb-row--full-width": appearance === "full-width",
  });

  if (imgUrl) {
    return (
      <BackgroundImageViaCss
        className={classes}
        src={imgUrl}
        data-pb-style={styleId}
      >
        {children}
      </BackgroundImageViaCss>
    );
  }

  return (
    <div className={classes} data-pb-style={styleId}>
      {children}
    </div>
  );
};

const propTypes = {
  data: PropTypes.shape({
    appearance: PropTypes.oneOf(["contained", "full-bleed", "full-width"])
      .isRequired,
    backgroundImage: PropTypes.string,
    className: PropTypes.string,
    styleId: PropTypes.string,
  }),
};

Row.propTypes = propTypes;

export default Row;
